import { Computer, Forum, Inventory, LocalActivity, Loyalty, Person } from "@mui/icons-material"
import { DropShipperTypeId, SupplierTypeId } from "./utils"

const Navigations = [
  {
    label: 'Dashboard',
    icon: <Computer />,
    alertTypes: [],
    path: '/'
  },
  {
    label: 'Order Management',
    icon: <Inventory />,
    alertTypes: [],
    children: [
      {
        label: 'Orders',
        icon: <Inventory />,
        alertTypes: ['orderPlaced'],
        path: '/order-management/orders'
      },
    ]
  },
  {
    label: 'External Store',
    role: [DropShipperTypeId],
    icon: <LocalActivity />,
    alertTypes: [],
    path: '/external-store'
  },
  {
    label: 'Listed Products',
    role: [DropShipperTypeId],
    icon: <LocalActivity />,
    alertTypes: [],
    path: '/listed-products'
  },
  {
    label: 'Transactions',
    icon: <LocalActivity />,
    alertTypes: [],
    path: '/transactions'
  },
  {
    label: 'Refund and Return',
    icon: <LocalActivity />,
    alertTypes: [],
    path: '/refund-return'
  },
  {
    label: 'Membership Plan',
    role: [DropShipperTypeId, SupplierTypeId],
    icon: <Loyalty />,
    alertTypes: [],
    children: [
      {
        label: 'Activate Membership',
        icon: <Loyalty />,
        alertTypes: [],
        path: '/membership-plan/activate-membership'
      },
      {
        label: 'Update Membership',
        icon: <Loyalty />,
        alertTypes: [],
        path: '/membership-plan/update-membership'
      },
    ]
  },
  {
    label: 'Chat',
    icon: <Forum />,
    alertType: ['newChatAlert'],
    path: '/chat'
  },
  {
    label: 'Profile',
    icon: <Person />,
    alertTypes: [],
    path: '/profile'
  },
]

export default Navigations